import { motion, useReducedMotion } from "framer-motion";
import { Waves, Timer, Scale } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { motionMedia } from "@/content/site";
import { Reveal, SectionHead } from "@/components/apex/primitives";

const ICONS = [Waves, Timer, Scale];

const PivotMotion = () => {
  const { t, isRtl } = useLang();
  const reduce = useReducedMotion();

  return (
    <section data-testid="pivot-section" className="relative py-14 sm:py-20">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <Reveal delay={0.1}>
          <figure style={{ perspective: "1600px" }} data-testid="pivot-visual" className="relative">
            <motion.div
              initial={reduce ? false : { rotateY: isRtl ? 22 : -22, opacity: 0 }}
              whileInView={{ rotateY: 0, opacity: 1 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
              style={{ transformOrigin: isRtl ? "right center" : "left center" }}
              className="ap-img h-[440px] sm:h-[600px]"
            >
              <img
                src={motionMedia.image}
                alt={isRtl ? motionMedia.alt_ar : motionMedia.alt_en}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover"
                style={{ objectPosition: "45% 85%" }}
              />
            </motion.div>
            <figcaption className="ap-card absolute bottom-6 start-6 max-w-[260px] px-5 py-4 text-[13px] leading-relaxed text-[var(--text)] shadow-[0_24px_50px_-28px_rgba(21,21,21,0.4)]">
              {t.pivot.caption}
            </figcaption>
          </figure>
        </Reveal>

        <div>
          <SectionHead label={t.pivot.label} title={t.pivot.title} />
          <ul className="mt-10 space-y-4">
            {t.pivot.items.map((item, i) => {
              const Icon = ICONS[i] || Waves;
              return (
                <Reveal key={item.t} delay={0.06 * i}>
                  <li className="ap-card ap-card-hover group flex items-start gap-5 p-6">
                    <span className="ap-icon">
                      <Icon className="h-6 w-6" strokeWidth={1.7} />
                    </span>
                    <div>
                      <h3 className="ap-display text-lg text-[var(--text)] sm:text-xl">{item.t}</h3>
                      <p className="mt-2 text-[14px] leading-[1.8] text-[var(--muted)]">{item.d}</p>
                    </div>
                  </li>
                </Reveal>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PivotMotion;
